import { IconTablePlus } from "@tabler/icons-react";
import React from "react";

import { NativeSelect, type NativeSelectProps, RichTextEditor, type RichTextEditorControlProps, useRichTextEditorContext } from "~/ui";

import styles from "./table.module.css";

export const TableInsertControl = React.forwardRef<HTMLButtonElement, RichTextEditorControlProps>(function TableInsertControl(props, ref) {
  const { editor } = useRichTextEditorContext();

  return (
    <RichTextEditor.Control
      active={editor?.isActive("insertTable")}
      aria-label="Insert Table"
      interactive
      onClick={() => editor?.chain().focus().insertTable().run()}
      ref={ref}
      title="Insert Table"
      {...props}
    >
      <IconTablePlus size="1rem" stroke={1.5} />
    </RichTextEditor.Control>
  );
});

export const TableActionsControl = (props: Omit<NativeSelectProps, "data">) => {
  const { editor } = useRichTextEditorContext();
  const value = "";
  const exec = (cmd: string) => {
    if (cmd.length === 0) {
      return;
    }
    // biome-ignore-start lint/suspicious/noTsIgnore: carried over from the ESLint suppression
    // @ts-ignore
    editor?.chain().focus()[cmd]().run();
    // biome-ignore-end lint/suspicious/noTsIgnore: carried over from the ESLint suppression
  };

  return (
    <NativeSelect
      disabled={!editor.can().deleteTable()}
      inputClassName={styles.input}
      {...props}
      value={value}
      onChange={e => exec(e.currentTarget.value)}
      data={[
        { value: "", label: "Table Commands" },
        { value: "addColumnBefore", label: "Insert Column Before" },
        { value: "addColumnAfter", label: "Insert Column After" },
        { value: "deleteColumn", label: "Delete Column" },
        { value: "addRowBefore", label: "Insert Row Before" },
        { value: "addRowAfter", label: "Insert Row After" },
        { value: "deleteRow", label: "Delete Row" },
        { value: "deleteTable", label: "Delete Table" },
        { value: "mergeCells", label: "Merge Cells" },
        { value: "splitCell", label: "Split Cell" },
        { value: "toggleHeaderColumn", label: "Toggle Header Column" },
        { value: "toggleHeaderRow", label: "Toggle Header Row" },
        { value: "toggleHeaderCell", label: "Toggle Header Cell" },
      ]}
      placeholder="Table"
    />
  );
};
